import {Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from "@angular/core";
import {getAnimationTrigger} from "@utils/animations";
import {environment} from "@env";

@Component({
    selector: "app-modal",
    templateUrl: "./modal.component.html",
    styleUrl: "./modal.component.scss",
    animations: [getAnimationTrigger(environment.animation_delay_in_ms.trigger)],
})
export class ModalComponent<A extends HTMLElement> {
    @Input() isVisible: boolean = false;
    @Input() isHideHeader: boolean = false;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    public closeModal(): void
    {
        this.onClose.emit();
    }

    // @HostListener('document:click', ['$event.target'])
    // public onClick(targetElement: any): void {
    //     console.log(this.modalActivator);
    //     console.log(targetElement);
    //     const clickActivator = this.modalActivator?.contains(targetElement);
    //     if (clickActivator || !this.modal?.nativeElement) {
    //         return
    //     }
    //
    //     const clickedInside = this.modal.nativeElement.contains(targetElement);
    //     if (!clickedInside) {
    //         this.closeModal();
    //         // this.actionPanelOpen = false;
    //     }
    // }
}
